export default {
    title: 'Branches',
    searchPlaceholder: 'Search branches...',
    columns: {
        name: 'Name',
        location: 'Location',
        abbr: 'Abbr',
        initialContractId: 'Initial Contract ID',
        center: 'Center',
        qbLocation: 'QB Location',
        parent: 'Parent Branch',
        depositAccounts: 'Deposit Accounts',
        visps: 'Mapped VISPs',
        contractInfo: 'Contract Info',
        receiptInfo: 'Receipt Template'
    },
    tabs: {
        general: 'General Info',
        contract: 'Contract Info',
        receipt: 'Payment Receipt',
        integration: 'System & Accounts'
    },
    contractInfo: {
        sectionTitle: 'Contract Information',
        language: 'Contract Language',
        selectLanguage: 'Select Language',
        phone: 'Contract Phone Number',
        phonePlaceholder: 'e.g. +93799656580 or 0711656580',
        address: 'Contract Branch Address',
        addressPlaceholder: 'e.g. Blood Bank St, Imam Muslim 11, Herat',
        languages: {
            fa: 'Persian / Dari (فارسی / دری)',
            ps: 'Pashto (پښتو)',
            mazar: 'Mazar (مزار شریف)'
        }
    },
    receiptInfo: {
        sectionTitle: 'Payment Receipt Settings',
        template: 'Receipt Print Template',
        templateText: 'Text Only (Pre-printed Paper)',
        templateFull: 'Full Design with Header & Footer (Blank Paper)',
        phone: 'Customer Support Phone in Receipt',
        phonePlaceholder: '0787315151 / 0728315151 (Default)',
        phoneHint: 'If left empty, default customer support numbers (0787315151 / 0728315151) will be displayed.',
        address: 'Receipt Branch Address',
        addressPlaceholder: 'Receipt specific address (optional)',
        addressHint: 'If empty, contract branch address will be used.',
        preprintedNotice: 'Pre-printed papers already include official contact info and header; no dynamic printing needed.'
    },
    account: 'account',
    accounts: 'accounts',
    actions: {
        add: 'Add',
        edit: 'Edit',
        delete: 'Remove Branch',
        copyId: 'Copy Branch ID',
        update: 'Update Branch'
    },
    dialog: {
        add: {
            title: 'Add New Branch',
            description: 'Enter the details for the new branch here. Click save when you\'re done.'
        },
        update: {
            title: 'Update Branch',
            description: 'Update the details for this branch. Click save when you\'re done.'
        },
        save: 'Save changes',
        cancel: 'Cancel'
    },
    fields: {
        generalInfo: 'General Information',
        integrationSettings: 'Integration & Server Settings',
        name: 'Name',
        location: 'Location',
        abbr: 'Abbr',
        initialContractId: 'Initial Contract ID',
        initialContractIdPlaceholder: '',
        center: 'Center',
        selectCenter: 'Select Center',
        loadingCenters: 'Loading...',
        radiusServer: 'Radius Server',
        selectRadiusServer: 'Select Radius Server',
        noRadiusServer: 'No Radius Server',
        loadingRadiusServers: 'Loading Radius Servers...',
        visps: 'Mapped VISPs',
        selectVisps: 'Select VISP(s)',
        searchVisps: 'Search VISPs...',
        loadingVisps: 'Loading VISPs...',
        noVisps: 'No VISPs found',
        noMatchingVisps: 'No matching VISPs',
        selectRadiusFirstForVisps: 'Select a Radius Server first',
        vispsAvailable: 'VISPs available',
        defaultVisp: 'Default VISP',
        selectDefaultVisp: 'Select Default VISP',
        noDefaultVisp: 'No Default (Auto)',
        selectVispsFirst: 'Select VISPs first',
        qbLocation: 'QB Location',
        selectQbLocation: 'Select QB Location',
        loadingQbLocations: 'Loading...',
        selectLocation: 'Select QB Location',
        loadingLocations: 'Loading...',
        parent: 'Parent Branch',
        selectParent: 'Select Parent Branch',
        noParent: 'No Parent',
        loadingBranches: 'Loading...',
        useParentContract: 'Use Parent Contract Sequence',
        useParentContractDescription: 'When enabled, new customers in this branch will share the contract ID sequence of the parent branch.',
        qboDepositAccounts: 'QBO Deposit Accounts',
        selectDepositAccounts: 'Select deposit accounts',
        searchDepositAccounts: 'Search deposit accounts...',
        loadingDepositAccounts: 'Loading deposit accounts...',
        noDepositAccounts: 'No deposit accounts found',
        noMatchingAccounts: 'No matching accounts',
        selected: 'selected',
        clearSelection: 'Clear',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
    },
    notifications: {
        idCopied: {
            title: 'Branch ID Copied',
            description: 'The branch ID has been copied to your clipboard.'
        },
        deleted: {
            title: 'Branch Deleted',
            description: 'The branch has been successfully deleted.'
        },
        error: {
            title: 'Error',
            description: 'Failed to delete the branch. Please try again.'
        }
    }
} 